// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2awvY","colMin":"styles_colMin__2WhnQ"};